import { AppFlow } from './app-flow';

export type AppFlowType = AppFlow['type'];
